<div class="modals" [class.modals-show]="isModalShow">
  <div class="np-nalojki-info-head">
    <p>Увага!</p>
    <div class="interest">
      <p>Замовні позиції обміну та поверненню не підлягають.</p>
      <p>Партнерський склад – це замовна позиція.</p>
      <p>Терміни доставки партнерських пропозицій можуть змінюватись, можуть бути відмови постачання.</p>
    </div>
  </div>
  <div class="np-nalojki-info-buttons-container">
    <button class="button" (click)="notAgree()">Не згоден</button>
    <button class="button" (click)="agree()">Згоден</button>
    <button class="button" (click)="agreeNotShowMore()">
      Згоден більше не нагадувати
    </button>
  </div>
</div>
<div class="dark-layer" [class.modals-show]="isDarkBackground"></div>
